import { useState, useEffect } from 'react';
import LoginPage from './pages/LoginPage';
import AdminPortfolio from './pages/AdminPortfolio';
import CompanyDashboard from './pages/CompanyDashboard';
const API = process.env.REACT_APP_API_URL || '';
export default function App() {
  const [user, setUser] = useState(undefined);
  const slug = window.location.pathname.replace('/', '').split('/')[0] || null;
  useEffect(() => { fetch(`${API}/api/auth/me`, { credentials: 'include' }).then(r => r.json()).then(d => setUser(d.user || null)).catch(() => setUser(null)); }, []);
  const handleLogout = () => { fetch(`${API}/api/auth/me`, { method: 'POST', credentials: 'include' }); setUser(null); };
  if (user === undefined) return <div className="loading-screen"><div className="portal-logo">SCV</div><p>Loading...</p></div>;
  if (!user) return <LoginPage onLogin={setUser} slug={slug} />;
  if (user.role === 'scv_admin') {
    if (slug && slug !== '') return <CompanyDashboard slug={slug} user={user} onLogout={handleLogout} />;
    return <AdminPortfolio user={user} onLogout={handleLogout} />;
  }
  return <CompanyDashboard slug={user.companySlug} user={user} onLogout={handleLogout} />;
}
